import React from 'react';
import { useIntl } from 'react-intl';

import { Grid, Notification } from '@xsolla/ui-core';
import { AlertExclamation } from '@xsolla/ui-icons';

import { usePaths } from '../../../routes/routesHelper';
import { linkTo } from '../../../utils';
import { ApiIcon, CallbackUrlIcon, LinkStylesUnderline, SocialIcon, ToggleBox } from '../../ui';
import NavigationSettingsLink from '../NavigationSettingsLink';
import { ContentWrapper, NotificationWrapper } from './style';

type Props = {
  projectId: string;
};

const SocialLoginSettings = ({ projectId }: Props): JSX.Element => {
  const { apiSettingsPath, callbackUrlsSettingsPath, changeMethodPath, socialConnectionPath } =
    usePaths();
  const intl = useIntl();

  return (
    <ToggleBox
      title={intl.messages['navigation.settings.social.label']}
      openByDefault
      dataTestId="navigation-block-auth">
      <ContentWrapper>
        <NotificationWrapper>
          <Notification icon={AlertExclamation}>
            <LinkStylesUnderline data-test-id="change-project-type">
              {intl.formatMessage(
                { id: 'navigation.settings.classic-login.alert' },
                linkTo({ href: changeMethodPath(projectId) })
              )}
            </LinkStylesUnderline>
          </Notification>
        </NotificationWrapper>
        <Grid cols={2} gap={24}>
          <NavigationSettingsLink
            dataTestId="link-navigation-callback-urls"
            icon={<CallbackUrlIcon />}
            titleInfo={{
              label: intl.messages['navigation.settings.callback.title'],
              path: callbackUrlsSettingsPath(projectId)
            }}
            subtitle={intl.messages['navigation.settings.callback.subtitle']}
          />
          <NavigationSettingsLink
            dataTestId="link-navigation-social-settings"
            icon={<SocialIcon />}
            titleInfo={{
              label: intl.messages['navigation.settings.authentication.social-connections.title'],
              path: socialConnectionPath(projectId)
            }}
            subtitle={
              intl.messages['navigation.settings.authentication.social-connections.subtitle']
            }
          />
          <NavigationSettingsLink
            dataTestId="link-navigation-api-settings"
            icon={<ApiIcon />}
            titleInfo={{
              label: intl.messages['navigation.settings.authentication.api-settings.title'],
              path: apiSettingsPath(projectId)
            }}
            subtitle={intl.messages['navigation.settings.authentication.api-settings.subtitle']}
          />
        </Grid>
      </ContentWrapper>
    </ToggleBox>
  );
};

export default SocialLoginSettings;
